import store from '../../../store/store';
import { REPORT_GRAPHS_API } from '../../constants/central-api';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';

/** ===== Function to get base64 string for a graph by its ID ===== */
export default async function get_base64_string_api_call(graphID: string) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: `${REPORT_GRAPHS_API(shopSlug)}/${graphID}/download`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'GET_BASE64_STRING';
    const customMsg = 'Base64 string retrieved successfully';

    const res: any = await asyncHandler(requestInfo, actionType, customMsg);

    const response = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response?.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during get base64 string request');
    return null;
  }
}
